<script lang="ts">
  import { weekRangeLabel } from '$lib/utils/weekLabel';

  interface SeasonWin {
    rank: number;
    season_number: number;
    points: number;
    // Only present since the getUserSeasonWins() date projection (week
    // rework, item A) — older cached responses / other callers may omit
    // these, so the date-range subtitle stays tolerant of their absence.
    start_date?: string;
    end_date?: string;
  }

  let { seasonWins }: { seasonWins: SeasonWin[] | null | undefined } = $props();
</script>

{#if seasonWins && seasonWins.length > 0}
  <div class="section">
    <h2>Week Trophies</h2>
    <div class="season-trophies">
      {#each seasonWins as win}
        <span class="trophy-badge">
          <span class="trophy-main">
            {win.rank === 1 ? '🏆' : win.rank === 2 ? '🥈' : '🥉'}
            Week {win.season_number}
            <span class="trophy-pts">{win.points} pts</span>
          </span>
          {#if win.start_date && win.end_date}
            <span class="trophy-range">{weekRangeLabel(win.start_date, win.end_date)}</span>
          {/if}
        </span>
      {/each}
    </div>
  </div>
{/if}

<style>
  .section {
    margin-top: 2rem;
  }
  .section h2 {
    font-size: 1rem;
    margin-bottom: 0.75rem;
  }
  .season-trophies {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
  }
  .trophy-badge {
    display: inline-flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.15rem;
    padding: 0.4rem 0.75rem;
    background: var(--surface);
    border: 1px solid var(--border);
    border-radius: 12px;
    font-size: 0.85rem;
    font-weight: 600;
    color: var(--text);
  }
  .trophy-main {
    display: inline-flex;
    align-items: center;
    gap: 0.35rem;
  }
  .trophy-pts {
    font-size: 0.75rem;
    color: var(--text-muted);
    font-weight: 400;
  }
  .trophy-range {
    font-size: 0.7rem;
    color: var(--text-muted);
    font-weight: 400;
  }
</style>
